module.exports = __webpack_public_path__ + "static/media/draftScreenIcon.952458dc.svg";